import { Durations } from '@/constants/durations'
import { paths } from '@/constants/paths'
import { Seo, getBasicPageMetaData } from '@/layout/Seo'
import { PIFExplainerLayout } from '@/layouts/PifExplainerLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { MarketingVideoPopup } from '@/organisms/MarketingVideoPopup'
import { getPifProjects } from '@/services/PifService'
import { Project } from '@/services/ProjectsService'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { PifExplainerView } from '@/views/PifExplainerView/PifExplainerView'

interface PayItForwardExplainerProps {
  locale: string
  projects: Project[]
}

export const PayItForwardExplainer: NextPageWithLayout<PayItForwardExplainerProps> = ({ locale, projects }) => {
  const { t } = useTranslate('pif')
  return (
    <>
      <Seo
        {...getBasicPageMetaData({
          cloudinaryImagePath: 'v1706828895/angel-studios/pif/Meta_Data_Image_-_PIF_Explainer.png',
          cloudinaryTransformation: 'b_rgb:000000',
          description: t(
            'angelStudiosPifMetaDescriptionV3',
            `Pay it Forward empowers fans to allow other people to receive free movie tickets and stream movies and shows online`,
          ),
          locale,
          path: paths.payItForward.index,
          title: t('angelPifMetaTitle', 'Pay it Forward | Angel'),
        })}
      />
      <MarketingVideoPopup />
      <PifExplainerView projects={projects} />
    </>
  )
}

export const getStaticProps = getStaticPropsErrorHandler<PayItForwardExplainerProps>(
  { filePath: 'pages/[locale]/pay-it-forward/index.tsx' },
  async ({ locale, federationClient }) => {
    const [projects, translations] = await Promise.all([
      getPifProjects(federationClient),
      loadTranslations(locale, ['common', 'pif', 'account']),
    ])

    return {
      props: {
        locale,
        projects,
        ...translations,
      },
      revalidate: Durations.ONE_HOUR_IN_SECONDS,
    }
  },
)

PayItForwardExplainer.getLayout = (page) => {
  return <PIFExplainerLayout>{page}</PIFExplainerLayout>
}

export const getStaticPaths = getGenericStaticPaths

export default PayItForwardExplainer
